<form [formGroup]="formSelector">
  <mat-form-field fxFlex="100" appearance="outline">
    <mat-label>{{ placeholder | translate }}</mat-label>
    <mat-select
      #matSelectInfiniteScroll
      msInfiniteScroll
      (infiniteScroll)="getNextBatch()"
      [attr.data-cucumber-id]="cucumberId"
      [id]="id"
      formControlName="selectorCustom"
      [multiple]="isMultiple"
      (valueChange)="onChange($event)"
      (selectionChange)="onSelectionChange($event)"
    >
      <mat-option [ngClass]="dataInput?.length <= 1 && !isCTI ? 'select__option--hidden' : null">
        <ngx-mat-select-search
          [attr.data-cucumber-id]="cucumberId + '-search'"
          [formControl]="searchCtrl"
          placeholderLabel="{{'select.search' | translate}}"
          [disableScrollToActiveOnOptionsChanged]="true"
          [showToggleAllCheckbox]="isMultiple && !hideSearch"
          [toggleAllCheckboxChecked]="isToogledAllChecked"
          (toggleAll)="toggleAllSelection($event)"
          noEntriesFoundLabel="{{'select.empty' | translate}}"
          (keydown)="_keydown($event)"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngIf="hasSelectOptionEmpty && isVisible"
        [attr.data-cucumber-id]="cucumberId + '-empty'"
        value=""
      ></mat-option>
      <mat-option *ngIf="hasSelectOptionAll && isVisible" value=""
        >{{'select.option.all' | translate | uppercase}}</mat-option
      >
      <mat-option
        *ngFor="let option of options$ | async"
        [attr.data-cucumber-id]="cucumberId + '-' + option[selectorIdProperty]"
        [value]="getValue(option, option[selectorValueProperty], option[selectorIdProperty])"
        [disabled]="isToogledAllChecked && isMultiple"
        (onSelectionChange)="onSelectionOptionChange($event, option[selectorIdProperty],option)"
      >
        {{hasToTranslateValue ? (option[selectorValueProperty] | translate) : id === 'town' ? ( option['codPostal'] ?
        option[selectorValueProperty] + ' ('+ option['codPostal'] +')' : option[selectorValueProperty] ) :
        option[selectorValueProperty] }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="formSelector?.controls.selectorCustom?.errors?.required" translate> field.required </mat-error>
    <mat-error *ngIf="formSelector?.controls.selectorCustom?.errors?.showErrorCalculate" translate>
      field.required
    </mat-error>
    <mat-error *ngIf="formSelector?.controls.selectorCustom?.errors?.avalistaError" translate
      >field.error.avalista</mat-error
    >
  </mat-form-field>
</form>
